import { StreamChat, User } from 'stream-chat';

import { getToken } from './api';

let globalStreamChatClient: StreamChat | null = null;

export const initializeStreamChatClient = async (
  apiKey: string,
  user: User
): Promise<StreamChat> => {
  if (!globalStreamChatClient) {
    globalStreamChatClient = StreamChat.getInstance(apiKey);
  }

  if (!globalStreamChatClient.userID) {
    await globalStreamChatClient.connectUser(user, async () => {
      const token = await getToken();
      return token.token;
    });
  }

  return globalStreamChatClient;
};

export const getStreamChatClient = () => globalStreamChatClient;
